import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

window.addEventListener('error', (event) => {
  const message = event.message || '';
  if (
    message.includes('ChunkLoadError') ||
    message.includes('Loading chunk') ||
    message.includes("Unexpected token '<'")
  ) {
    const reloaded = sessionStorage.getItem('devalpha_chunk_reload');
    if (!reloaded) {
      sessionStorage.setItem('devalpha_chunk_reload', '1');
      window.location.reload();
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
